import { Box, FormControlLabel, Switch } from "@mui/material";
import { connect } from "react-redux";
import { selectModeData, selectProject } from "../../../redux/selectors/editor";
import { IGraphData, updateFocus, UpdateModeData, updateModeData } from "../../../redux/slices/editor";
import { selectConstants, selectNetwork, selectProjects, selectTags, selectUser } from "../../../redux/selectors/firebase";
import { PathwayUser, Projects } from "../../../redux/types/firebase";
import OrderableData from "../../dialogs/project/OrderableData";
import { Constants, Tags } from "../StateTags";
import { useMemo, useState } from "react";
import { NetworkData } from "../../../fstn/network";
import { getNodesInRoot } from "../../../utility/networkUtils";

interface IProps
{
    user: PathwayUser
    tags: Tags,
    project: string,
    projects: Projects,
    graphData: IGraphData,
    constants: Constants,
    network: NetworkData,
    updateFocus: (focus: string) => void
    updateModeData: UpdateModeData
}
function ScriptSequence({ user, tags, constants, network, project, projects, graphData, updateFocus, updateModeData }: IProps)
{
    const projectDetails = projects[project];
    const [filterStatesInRoot, setFilterStatesInRoot] = useState(true);
    let content = null;

    const statesInRoot = useMemo(() => getNodesInRoot(graphData.root, network), [network, graphData.root]);

    const focusSequenceValue = (value: string | number | boolean) =>
    {
        const state = Object.keys(network.states).find((state) => state in tags && Object.values(tags[state])
            .find((tag) => tag.type === projectDetails.scriptSequenceTag && tag.value === value));

        if (state)
        {
            if (graphData.root !== network.states[state].parent)
            {
                updateModeData({ root: network.states[state].parent })
            }
            updateFocus(state);
        }
    }

    const selectSequenceOfValue = (value: string | number | boolean) =>
    {
        const selected = Object.keys(network.states).filter((state) => state in tags && Object.values(tags[state])
            .find((tag) => tag.type === projectDetails.scriptSequenceTag && tag.value === value));
        if (selected.length > 0)
        {
            updateModeData({ selected, selectedActive: selected[0] });
        }
    }

    if (projectDetails.scriptSequenceTag !== undefined)
    {
        const constant = constants[projectDetails.scriptSequenceTag];
        const constraintEntry = Object.entries(constant.constraints ?? {}).find(([id, constraint]) => constraint.type === "orderable");
        if (constraintEntry)
        {
            const [id, constraint] = constraintEntry;
            content = <>
                <FormControlLabel control={
                    <Switch checked={filterStatesInRoot} onChange={() => setFilterStatesInRoot(!filterStatesInRoot)} />
                } label="Show visible" />
                <OrderableData constraint={constraint}
                    stateFilter={filterStatesInRoot ? statesInRoot : undefined}
                    project={project}
                    constant={projectDetails.scriptSequenceTag}
                    focusSequenceValue={focusSequenceValue}
                    selectSequenceOfValue={selectSequenceOfValue}
                    id={id} admin={user.roles.admin === true} />
            </>
        }
    }

    return <Box>
        {content}
    </Box>
}
const mapStateToProps = (store: never) => ({
    graphData: selectModeData(store) as IGraphData,
    tags: selectTags(store),
    project: selectProject(store),
    projects: selectProjects(store),
    constants: selectConstants(store),
    network: selectNetwork(store),
    user: selectUser(store)
});

export default connect(mapStateToProps, {
    updateFocus,
    updateModeData
})(ScriptSequence);
